import React from 'react';
import PlannerFrame from './PlannerFrame';

const ForkliftPlanner = () => {
  return (
    <PlannerFrame
      title="Forklift Planner"
      src="/forklift-planner.html"
    />
  );
};

export default ForkliftPlanner;